import { render } from "./ViewLeitura.vue?vue&type=template&id=395c51d7&scoped=true"
import script from "./ViewLeitura.vue?vue&type=script&lang=js"
export * from "./ViewLeitura.vue?vue&type=script&lang=js"

import "./ViewLeitura.vue?vue&type=style&index=0&id=395c51d7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395c51d7"]])

export default __exports__